import type { TFunction } from "i18next";

import { errorDetailOr, statusOf } from "@/lib/api-error";

/**
 * Motivo de um Save (ou teste) de conexão que falhou, para mostrar no próprio formulário.
 *
 * O 403 é papel abaixo de consultor: a rota de escrita exige CONSULTANT e a de leitura
 * só USER, então a pessoa vê o formulário e não consegue salvar. Ele ganha frase própria,
 * que diz o que fazer; o resto é o motivo do servidor ou a frase de quem chamou.
 */
export function connectionSaveFailureText(t: TFunction, error: unknown, fallback: string): string {
  if (statusOf(error) === 403) {
    return t("Your role cannot save this connection. Ask a project consultant or admin.");
  }
  return errorDetailOr(error, fallback);
}
